import { useEffect } from "react";
import { useRef } from "react";

const useAutoScrollToBottom = (data) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
      });
    }
  }, [data]);

  return ref;
};

export default useAutoScrollToBottom;
